// @ts-check

const isProd = !['localhost', 'beta.models.com'].includes(window.location.hostname)
const API_HOSTNAME = isProd ? 'https://api.models.com' : 'https://beta-api.models.com'
const API_PATH = `${API_HOSTNAME}/prosearch/findPeople.html`
export const HOSTNAME = isProd ? 'https://models.com' : 'https://beta.models.com'
const IMAGE_UPLOAD_HOSTNAME = HOSTNAME
const IMAGE_UPLOAD_API_PATH = `${IMAGE_UPLOAD_HOSTNAME}/account/agency-listing/edit/imageUpload.html`

export const API_SERVER_NAME = API_HOSTNAME
export const API_URL = API_PATH

// reducer actions
export const LOADING = 'loading'
export const SUCCESS = 'success'
export const ERROR = 'error'

/**
 * @param {any} request
 * @returns {string}
 */
function urlWithNotificationReset(request) {
  if (request.hasOwnProperty('Notifications')) {
    return `${API_PATH}?mdcdbapi=true&Notifications=1`
  } else {
    sessionStorage.setItem('notificationLP', '0')
    return `${API_PATH}?mdcdbapi=true`
  }
}

/**
 * @param {any} request
 * @returns {Promise<any>}
 */
export async function fetchData(request) {
  /** @type {RequestInit} */
  const options = {
    credentials: 'include',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  }
  const responseRaw = await fetch(urlWithNotificationReset(request), options)
  if (!responseRaw.ok) {
    throw `Request returned unsuccessfully. Status Code:  ${responseRaw.status}`
  }
  return await responseRaw.json()
}

/**
 * @param {FormData} request
 * @returns {Promise<any>}
 */
export async function uploadImage(request) {
  /** @type {RequestInit} */
  const options = {
    credentials: 'include',
    method: 'POST',
    body: request,
  }
  const responseRaw = await fetch(IMAGE_UPLOAD_API_PATH, options)
  if (!responseRaw.ok) {
    throw `Request returned unsuccessfully. Status Code:  ${responseRaw.status}`
  }
  return await responseRaw.json()
}

/**
 * @typedef {(action: { type: string, [key: string]: any }) => void} Dispatch
 */

/**
 * @param {() => Promise<any>} fn
 * @param {Dispatch} dispatch
 * @returns {Promise<boolean>}
 */
async function withDispatch(fn, dispatch) {
  try {
    dispatch({ type: LOADING })
    const response = await fn()
    if (response && response.success) {
      dispatch({ type: SUCCESS, ...response })
    } else {
      dispatch({ type: ERROR, ...response })
      return false
    }
    return true
  } catch (err) {
    dispatch({ type: ERROR })
  }
  return false
}

/**
 * @param {any} request
 * @param {Dispatch} dispatch
 * @returns {Promise<boolean>}
 */
export async function fetchDataWithDispatch(request, dispatch) {
  return await withDispatch(async () => fetchData(request), dispatch)
}

/**
 * @param {FormData} request
 * @param {Dispatch} dispatch
 * @returns {Promise<boolean>}
 */
export async function uploadImageWithDispatch(request, dispatch) {
  return await withDispatch(async () => uploadImage(request), dispatch)
}
